import React from 'react';
import AirlineDetailPage from '../components/AirlineDetailPage';
import { CATHAY_PACIFIC } from '../data/airlinesData';

export default function CathayPacificPage() {
  return <AirlineDetailPage airline={CATHAY_PACIFIC} />;
}
